import { createContext, useContext } from "react";
import { useToast, type Toast } from "../hooks/useToast";
import ToastContainer from "../components/ToastContainer";

interface ToastContextValue {
  addToast: (message: string, type?: Toast["type"]) => void;
}

const ToastContext = createContext<ToastContextValue>({
  addToast: () => {},
});

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const { toasts, addToast, removeToast } = useToast();

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  const ctx = useContext(ToastContext);
  return {
    ...ctx,
    success: (msg: string) => ctx.addToast(msg, "success"),
    error: (msg: string) => ctx.addToast(msg, "error"),
    info: (msg: string) => ctx.addToast(msg, "info"),
  };
}

/** Alias for useToastContext */
export { useToastContext as useToast };
